import React, { Component } from "react";
import windowSize from "react-window-size";
import Aux from "components/utils/_Aux";
// import DEMO from "../../../../../../store/constant";
import * as Icon from "react-icons/fi";
class NavSearch extends Component {
  state = {
    searchWidth: this.props.windowWidth < 992 ? 90 : 0,
    searchString: this.props.windowWidth < 992 ? "90px" : "",
    isOpen: this.props.windowWidth < 992,
  };

  searchOnHandler = () => {
    this.setState({ isOpen: true });
    const searchInterval = setInterval(() => {
      if (this.state.searchWidth >= 91) {
        clearInterval(searchInterval);
        return false;
      }
      this.setState((prevSate) => {
        return {
          searchWidth: prevSate.searchWidth + 15,
          searchString: prevSate.searchWidth + "px",
        };
      });
    }, 35);
  };

  searchOffHandler = () => {
    const searchInterval = setInterval(() => {
      if (this.state.searchWidth < 0) {
        this.setState({ isOpen: false });
        clearInterval(searchInterval);
        return false;
      }
      this.setState((prevSate) => {
        return {
          searchWidth: prevSate.searchWidth - 15,
          searchString: prevSate.searchWidth + "px",
        };
      });
    }, 35);
  };

  render() {
    let searchClass = ["main-search"];
    if (this.state.isOpen) {
      searchClass = [...searchClass, "open"];
    }

    return (
      <Aux>
        <div id="main-search" className={searchClass.join(" ")}>
          <div className="input-group">
            <input
              type="text"
              id="m-search"
              className="form-control"
              placeholder="Search . . ."
              style={{ width: this.state.searchString }}
            />
            <a
              href={"#!"}
              className="input-group-append search-close"
              onClick={this.searchOffHandler}
            >
              <Icon.FiX
                className="feather icon-x"
                style={{ marginTop: "10px", marginRight: "10px" }}
              />
            </a>
            <span
              className="search-btn btn btn-primary balance"
              onClick={this.searchOnHandler}
            //   style={{ marginTop: "5px", marginLeft: "-5px" }}
            >
              <Icon.FiSearch className="feather icon-search" />
            </span>
          </div>
        </div>
      </Aux>
    );
  }
}

export default windowSize(NavSearch);
